import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownModule } from 'primeng/dropdown';
import { AutoCompleteModule, CalendarModule, CheckboxModule, GrowlModule } from 'primeng/primeng';
import { TableModule } from 'primeng/table';

import { CoreModule } from '../../core/core.module';
import { TaxReportComponent } from './tax-report.component';

@NgModule({
  imports: [
    AutoCompleteModule,
    CalendarModule,
    CheckboxModule,
    CommonModule,
    CoreModule,
    DropdownModule,
    FormsModule,
    GrowlModule,
    NgbModule,
    TableModule,
    TranslateModule
  ],
  declarations: [TaxReportComponent],
})
export class TaxReportModule {}



// WEBPACK FOOTER //
// /opt/app/src/app/features/tax-report/tax-report.module.ts